export default __webpack_public_path__ + "static/media/arrow-divider.c3e88866.svg";